/**
 * RYA eNav training forecasts, captured from rya-enavigation.org/weather (see the
 * enav-weather-capture note). The data is forecast TEXT — a shipping forecast for
 * a couple of dates and one inshore-waters forecast — for the fictional training
 * area. There's no point-wind grid on eNav, so this feeds the Forecasts & MSI
 * panels, not the barb overlay.
 *
 * The JSON is kept local (gitignored) like the eNav tide data; imported directly,
 * so a local build has it present.
 */
import data from './enav/forecasts.json';

export interface ShippingArea {
  name: string;
  forecast: string;
}
export interface ShippingForecast {
  date: string;
  issuedBy: string;
  synopsis: string;
  issuedAt: string;
  period: string;
  areas: ShippingArea[];
}
export interface InshoreArea {
  name: string;
  forecast24h: string;
  outlook: string;
}
export interface InshoreForecast {
  date: string;
  issuedBy: string;
  scope: string;
  generalSituation: string;
  issuedAt: string;
  period: string;
  areas: InshoreArea[];
}
interface ForecastsDoc {
  shippingForecasts: ShippingForecast[];
  inshoreForecasts: InshoreForecast[];
}

const doc = data as unknown as ForecastsDoc;

export const SHIPPING_FORECASTS: ShippingForecast[] = doc.shippingForecasts ?? [];
export const INSHORE_FORECASTS: InshoreForecast[] = doc.inshoreForecasts ?? [];

/** Shown on the panels so the training-only nature is always clear. */
export const FORECAST_SOURCE_NOTE =
  'RYA eNavigation training forecasts (fictional training area). Not for real-world navigation.';
